const getDateAsString = date => {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear()

  if (month.length < 2) month = '0' + month
  if (day.length < 2) day = '0' + day

  return [year, month, day].join('-')
}

const formatAmount = x => x.toLocaleString('de-DE', {minimumFractionDigits: 2})

const exportAsCsv = (defintion, data) => {
  let content = []
  content.push(defintion.map(m => `"${m.title}"`).join(';'))
  for (let i = 0; i < data.length; i++) {
    let line = []
    for (let j = 0; j < defintion.length; j++) {
      switch (defintion[j].formatter) {
        case 'date':
          line.push(
            `"${getDateAsString(new Date(data[i][defintion[j].property]))}"`,
          )
          break
        case 'amount':
          line.push(formatAmount(data[i][defintion[j].property]))
          break
        default:
          if (isNaN(data[i][defintion[j].property])) {
            if (data[i][defintion[j].property]) {
              line.push(
                `"${data[i][defintion[j].property]
                  .replace(/(\r\n|\n|\r)/gm, '')
                  .replace('#', '♯')
                  .replace('"', '\\"')}"`,
              )
            } else {
              line.push('""')
            }
          } else {
            line.push(`${data[i][defintion[j].property]}`)
          }

          break
      }
    }
    content.push(line.join(';'))
  }
  return content.join('\r\n')
}

const downloadCsvData = (content, fn) => {
  const encodedUri = encodeURI('data:text/csv;charset=utf-8,\uFEFF' + content)
  let link = document.createElement('a')
  link.setAttribute('href', encodedUri)
  link.setAttribute('download', fn + '.csv')
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export default {
  exportAsCsv,
  downloadCsvData,
}
